require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./extrascolaire-0-7-0.json") })
        }
      }, "path---extrascolaire-0-7-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---extrascolaire-0-7-0!./.cache/json/extrascolaire-0-7-0.json
// module id = 431
// module chunks = 231608221292675